// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 12) return "static/js/61bd550aaeff5650b23b.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"2d9aa18bcc9017841163","166":"abda772e1cfb45f681fc","167":"576f043ddac91984e557"}[chunkId] + ".chunk.js";
};